import { Controller } from "@hotwired/stimulus"

const SCRIPT_ID = "intercom-widget-script"
const DEFAULT_API_BASE = "https://api-iam.intercom.io"

export default class extends Controller {
  static values = {
    appId: String,
    apiBase: String,
    userJwt: String,
  }

  connect() {
    if (!this.hasAppIdValue || !this.hasUserJwtValue) return

    document.addEventListener("turbo:before-render", this.beforeRender)
    window.addEventListener("beforeunload", this.beforeUnload)

    this.ensureIntercomClient()
    this.bootOrUpdate()
  }

  disconnect() {
    document.removeEventListener("turbo:before-render", this.beforeRender)
    window.removeEventListener("beforeunload", this.beforeUnload)
  }

  beforeRender = (event) => {
    const newBody = event.detail?.newBody

    if (newBody?.dataset?.intercomEnabled === "true") return

    this.shutdown()
  }

  beforeUnload = () => {
    this.shutdown()
  }

  ensureIntercomClient() {
    if (typeof window.Intercom !== "function") {
      const intercom = function() {
        intercom.c(arguments)
      }

      intercom.q = []
      intercom.c = function(args) {
        intercom.q.push(args)
      }

      window.Intercom = intercom
    }

    if (document.getElementById(SCRIPT_ID)) return

    const script = document.createElement("script")
    script.id = SCRIPT_ID
    script.async = true
    script.src = `https://widget.intercom.io/widget/${this.appIdValue}`
    document.head.appendChild(script)
  }

  bootOrUpdate() {
    const settings = this.settings

    window.intercomSettings = settings

    if (window.__intercomBooted) {
      window.Intercom("update", settings)
      return
    }

    window.Intercom("boot", settings)
    window.__intercomBooted = true
  }

  shutdown() {
    if (typeof window.Intercom === "function" && window.__intercomBooted) {
      window.Intercom("shutdown")
    }

    window.__intercomBooted = false
    delete window.intercomSettings
  }

  get settings() {
    return {
      app_id: this.appIdValue,
      api_base: this.hasApiBaseValue ? this.apiBaseValue : DEFAULT_API_BASE,
      intercom_user_jwt: this.userJwtValue,
    }
  }
}
